// This is generated.  Alter it in blockGroups/filters/types/ByNavigationSelectionDropdownCriteria.js
/* eslint-disable no-unused-vars */
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      namespace,
      relation,
      criteriaProperty,
      foreignNamespace,
      foreignRelation,
    } = hNode;
    const criteriaElementPath = `${foreignNamespace}:${foreignRelation}`;
    //we don't know much. Hopefully from elsewhere there is a more complete definition.
    //But register what we know regardless, as that helps with finding incorrect configurations

    //we DO know that the navigated relation has a criteria object
    //And in it, there is at least 1 criteria: `propertyName`
    //We do NOT know what criteria operations it can contain, as that depends on if it is single, or multi select
    // We rely on registerForeignKey to declare the foreign namespace/relation exists.
    // The criteria structure is documented but not enforced in the data dictionary at this level.
    const subDataDictionary = {};
    //and we know that whatever relation context we are in, is expected to have this particular foreign key as property
    //but we don't know any fields on it
    // This filter identifies a foreign key; its requiredness must come from a form.
    const partialTypeDefinition = context.registerForeignKey(
      foreignNamespace,
      foreignRelation,
      [],
    );

    //And the given foreignKey exists on the parent object.
    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'filters',
  'ByNavigationSelectionDropdownCriteria',
  module.exports,
);
